import axios from 'axios';
import { Button, Input, message, Page, Space, Text } from 'components';
import { AuthContext } from 'contexts';
import React from 'react';
import styled from 'styled-components';
import { OBJECT_ID_REGEX } from 'utils/constants';

const API_URL = '/user/qa_page/reset_verify';

const buildUrl = (orgId?: string) => {
  if (orgId) {
    const searchParams = new URLSearchParams({ 'orgIds[]': orgId.trim() });
    return `${API_URL}?${searchParams.toString()}`;
  }
  return API_URL;
};

const buildFullUrl = (orgId?: string) => `${window.location.host}${buildUrl(orgId)}`;

const ResetVerifyPage = () => {
  const { auth } = React.useContext(AuthContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [orgId, setOrgId] = React.useState(auth.org.id || '');

  const fire = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      if (orgId) {
        const trimmedId = orgId.trim();
        if (!trimmedId.match(OBJECT_ID_REGEX)) {
          throw new Error(`${trimmedId} is not a valid object id`);
        }
      }
      const url = buildUrl(orgId);
      setIsLoading(true);
      await axios.get(url);
      message.success('Job Finished');
    } catch (error) {
      message.error(error?.toString(), 8);
    } finally {
      setIsLoading(false);
    }
  };

  const fullUrl = buildFullUrl(orgId);

  return (
    <Page type="filled" title="Reset Unverified Status QA Page">
      <Layout>
        <Text>This will reset the unverified state for all users</Text>
        <Text>
          A single org id can be specified (optional but recommended) to limit
          the job to one org
        </Text>
        <form onSubmit={fire}>
          <StyledInput
            addonAfter={
              <Button
                disabled={isLoading}
                loading={isLoading}
                htmlType="submit"
              >
                Trigger Job
              </Button>
            }
            defaultValue={orgId}
            onChange={e => setOrgId(e.target.value)}
            placeholder="Org Id"
          />
        </form>
        <Space>
          <Text>API route: {fullUrl}</Text>
          <Button onClick={() => navigator.clipboard.writeText(fullUrl)}>
            Copy Url
          </Button>
        </Space>
      </Layout>
    </Page>
  );
};

export default ResetVerifyPage;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;

const StyledInput = styled(Input)`
  width: 500px;
`;
